import { Languages, Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useAppSettings } from "./app-settings-provider";

export function PreferenceControls() {
  const { language, setLanguage, theme, setTheme, t } = useAppSettings();
  const nextLanguage = language === "en" ? "zh" : "en";
  const nextTheme = theme === "light" ? "dark" : "light";

  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        variant="secondary"
        className="h-8 px-2"
        title={language === "en" ? "Switch to Chinese" : "切换到英文"}
        onClick={() => setLanguage(nextLanguage)}
      >
        <Languages className="h-4 w-4" aria-hidden="true" />
        {t("controls.language")}
      </Button>
      <Button
        type="button"
        variant="secondary"
        className="h-8 px-2"
        title={theme === "light" ? "Enable dark theme" : "启用浅色主题"}
        onClick={() => setTheme(nextTheme)}
      >
        {theme === "light" ? <Moon className="h-4 w-4" aria-hidden="true" /> : <Sun className="h-4 w-4" aria-hidden="true" />}
        {theme === "light" ? t("controls.themeDark") : t("controls.themeLight")}
      </Button>
    </div>
  );
}
